import React, { useEffect, useState } from "react";
import MultipleAssignmentviewResult from "./MultipleAssignmentviewResult";
import "./MultipleAssignment.css";
import api from "../../api/api";
import MultipleAssignmentviewPopup from "./MultipleAssignmentviewPopup";
import { getAssignmentsByLesson, resetAssignmentsList } from "../../state/actions/getAssignmentsByLessonAction";
import { useAuth } from "../../features/auth/AuthContext";
import { useLocation, useNavigate, useParams } from "react-router";
import PaginationView from "../PaginationView/PaginationView";
import { useDispatch, useSelector } from "react-redux";
import { createAssignmentStatus } from "../../state/actions/createAssignmentStatusAction";
import LoadingComponent from "../LoadingComponent/LoadingComponent";
import { wsURL } from "../../api/api";
import { getPracticeAssignments } from "../../state/actions/getPracticeAssignmentsAction";
import dayjs from "dayjs";

function MultipleAssignment({ lesson, course, rubrics, setCurrentPage, currentPage, setrubricDetails }) {
    const navigate = useNavigate();
    const { token } = useAuth();
    const dispatch = useDispatch();
    const { lesson_id } = useParams();

    const [selectedAssignment, setSelectedAssignment] = useState(null);
    const [callWebSocket, setcallWebSocket] = useState(false);
    const [wsConnections, setWsConnections] = useState({});
    const [websocketPayload, setwebsocketPayload] = useState({
        practice_id: null,
        submission_id: null,
        assignment_id: null
    });
    const [selectedAssignmentIndex, setSelectedAssignmentIndex] = useState(null);
    const [assignmentPopUp, setAssignmentPopUp] = useState(false);
    const [assignmentRubric, setAssignmentRubric] = useState(null);
    const { count, next, previous, totalPages, error, assignments, isLoading } = useSelector((state) => state.getassignmentsbyLesson);
    const globalState = useSelector((state) => state.globalState);
    const studentId = globalState.student_details?.data?.student_id;
    const [ws, setWs] = useState(null);
    const location = useLocation();
    const courseType = course?.course_type

    useEffect(() => {
        if (location.state.practice_id) {
            setwebsocketPayload({
                practice_id: location.state.practice_id,
                submission_id: location.state.submission_id,
                assignment_id: location.state.assignment_id
            })
        }

    }, [location])

    useEffect(() => {
        const getRubric = async (lesson_id) => {
            const endpoint =
                courseType === 2
                    ? `competitive/assignments/get-rubric-by-lesson-id/${lesson_id}/`
                    : `assignments/get-rubric-by-lesson-id/${lesson_id}/`;

            await api
                .get(endpoint, {
                    headers: {
                        "Content-Type": "application/json",
                        Authorization: `Token ${token}`,
                    },
                })
                .then((response) => {
                    if (response.status === 200) {
                        setrubricDetails(response?.data?.data)
                    } else {
                    }
                })
                .catch((error) => { });
        };

        if (lesson_id) {
            getRubric(lesson_id)
        }

    }, [lesson_id])


    const startAssignmentPopupHandler = (assignment, index) => {

        setSelectedAssignment(assignment);
        setSelectedAssignmentIndex(index);
        let rubricId = null
        if (assignment.rubric_id !== null) {
            for (let i = 0; i < rubrics.length; i++) {
                if (assignment.rubric_id === rubrics[i].rubric_id) {
                    rubricId = rubrics[i]
                    break;
                }
            }
        }
        // setAssignmentRubric(rubrics[index] ? rubrics[index] : null);
        setAssignmentRubric(rubricId);
        setAssignmentPopUp(!assignmentPopUp);
    };
    const assignmentResultHandler = (assignment) => {

        setwebsocketPayload((prev) => {
            return {
                ...prev,
                submission_id: assignment?.submission?.submission_id,
                assignment_id: assignment.assignment_id
            };
        })

    }

    const enterFullscreen = () => {
        const elem = document.documentElement; // full page

        if (elem.requestFullscreen) {
            elem.requestFullscreen();
        } else if (elem.mozRequestFullScreen) { /* Firefox */
            elem.mozRequestFullScreen();
        } else if (elem.webkitRequestFullscreen) { /* Chrome, Safari & Opera */
            elem.webkitRequestFullscreen();
        } else if (elem.msRequestFullscreen) { /* IE/Edge */
            elem.msRequestFullscreen();
        }
    };


    const startAssignmentHandler = (status = 3) => {

        if (selectedAssignment?.course_type === 2) {
            enterFullscreen();
        }

        const course_id = course?.course_id;
        const lesson_id = lesson?.lesson_id;
        const id = selectedAssignment?.assignment_id;

        const payload = {
            student_id: globalState.student_details.data.student_id,
            assignment_id: id,
            status: 3,
            completed_name: selectedAssignment.name,
            assignment_type: 1,
        };

        dispatch(createAssignmentStatus(payload, token, courseType));

        try {
            const state = {
                course: JSON.parse(JSON.stringify(course)),
                lesson: JSON.parse(JSON.stringify(lesson)),
                assignment: selectedAssignment,
                rubric: assignmentRubric ? JSON.parse(JSON.stringify(assignmentRubric)) : null,
                assignmentDtls: assignments?.length > 0 ? JSON.parse(JSON.stringify(assignments)) : null,
                type: 1,
                goBack: location?.state?.goBack || null
            };

            navigate(`/course/${course_id}/lesson/${lesson_id}/assignment/${id}/preview`, { state });
        } catch (error) {
            console.error("Serialization error:", error);
        }
    };

    useEffect(() => {

        dispatch(getAssignmentsByLesson(lesson_id, currentPage, token, courseType));
    }, [currentPage])

    useEffect(() => {
        if (assignments?.length > 0) {
            assignments.forEach((assignment) => {
                if (assignment.submission) {
                    dispatch(getPracticeAssignments(assignment.assignment_id, token, courseType));
                }
            });
        }
    }, [assignments]);




    // useEffect(() => {

    //     const newWebSocketURL = `${wsURL}ws/practice_assignment/${studentId}/?token=${token}`;
    //     let reconnectInterval = 1000; // Initial reconnect interval in ms
    //     const maxReconnectInterval = 30000; // Max reconnect interval
    //     let reconnectAttempts = 0; // Number of reconnect attempts
    //     const reconnectDecay = 1.5; // Rate of increase of the reconnect delay
    //     const maxReconnectAttempts = 3; // Maximum number of reconnect attempts




    //     if (websocketPayload.practice_id && websocketPayload.submission_id) {
    //         let socket = new WebSocket(newWebSocketURL);
    //         setWs(socket);





    //         socket.onopen = () => {
    //             console.log("WebSocket connected");
    //             reconnectAttempts = 0; // Reset reconnect attempts on successful connection
    //             reconnectInterval = 1000; // Reset reconnect interval
    //             socket.send(JSON.stringify(
    //                 {
    //                     practice_id: websocketPayload.practice_id,
    //                     submission_id: websocketPayload.submission_id
    //                 }
    //             ));
    //             dispatch(getPracticeAssignments(websocketPayload.assignment_id, token));
    //         };

    //         socket.onmessage = (event) => {
    //             // console.log("WebSocket message received:", event.data);
    //             const data = JSON.parse(event.data);
    //             if (data.status === 200) {
    //                 if (data.data.practice_assignment_status === "Completed") {
    //                     dispatch(getPracticeAssignments(data.data.assignment_id, token));
    //                 }
    //                 setwebsocketPayload({
    //                     practice_id: null,
    //                     submission_id: null,
    //                     assignment_id: null
    //                 })
    //             }
    //         };

    //         socket.onclose = () => {
    //             console.log("WebSocket disconnected");
    //             if (reconnectAttempts < maxReconnectAttempts) {
    //                 setTimeout(() => {
    //                     reconnectAttempts++;
    //                     socket.close(); // Close old sockets if not yet closed
    //                     socket = new WebSocket(newWebSocketURL); // Create a new socket and attempt to connect
    //                     reconnectInterval = Math.min(reconnectInterval * reconnectDecay, maxReconnectInterval);
    //                 }, reconnectInterval);
    //             } else {
    //                 console.log("Max reconnect attempts reached, will not attempt further reconnects.");
    //             }
    //         };

    //         socket.onerror = (error) => {
    //             console.error("WebSocket error:", error);
    //             socket.close();
    //         };

    //         return () => {
    //             if (socket.readyState === 1) {
    //                 socket.close();
    //             }
    //         };
    //     }
    //     }, [websocketPayload.practice_id, websocketPayload.submission_id, callWebSocket]);


    // useEffect(() => {
    //     if (websocketPayload.practice_id && websocketPayload.submission_id) {
    //         initializeWebSocket(websocketPayload.practice_id, websocketPayload.submission_id, token);
    //     }

    //     // Cleanup all WebSockets when the component unmounts or websocketPayload changes
    //     return () => {
    //         Object.values(wsConnections).forEach(socket => {
    //             if (socket.readyState === WebSocket.OPEN) {
    //                 socket.close();
    //             }
    //         });
    //     };
    // }, [websocketPayload.practice_id, websocketPayload.submission_id, callWebSocket]);


    const currentDate = dayjs(); // Get current date


    return (
        <>
            <div className="maltiple-assignment-section">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12 col-md-12">
                            <div className="maltiple-assignment-wrapper mt-3">
                                {/* <div className="maltiple-assignment-card-container">

                                    {isLoading ?
                                        <div className="spinner-folder">
                                            <LoadingComponent
                                                loading_text="Educating the Future, Loading Now."
                                            />
                                        </div>
                                        : assignments?.length > 0 ?
                                            assignments?.map((assignment, index) => (

                                                <div className="maltiple-assignment-card-folder">
                                                    <MultipleAssignmentviewResult key={index} index={index} assignment={assignment} startAssignmentPopupHandler={startAssignmentPopupHandler} lesson={lesson} course={course} rubrics={rubrics} setcallWebSocket={setcallWebSocket}
                                                        callWebSocket={callWebSocket} setwebsocketPayload={setwebsocketPayload} assignmentResultHandler={assignmentResultHandler} courseType={courseType} />
                                                </div>
                                            ))
                                            : (
                                                <p style={{ textAlign: "center", marginTop: "20px" }}>No assignments found.</p>
                                            )
                                    }
                                </div> */}
                                <div className="maltiple-assignment-card-container">
                                {isLoading ? (
                                    <div className="spinner-folder">
                                        <LoadingComponent loading_text="Educating the Future, Loading Now." />
                                    </div>
                                ) : assignments?.length > 0 ? (
                                    assignments?.map((assignment, index) => {
                                        const assignmentStartDate = dayjs(assignment?.start_date); // Assignment's start date
                                        const isAssignmentAvailable = !currentDate.isBefore(assignmentStartDate); // Check if the assignment has started

                                        if (!isAssignmentAvailable) {
                                            return null; // If the assignment's start date is in the future, return null to hide it
                                        }

                                        return (
                                            <div className="maltiple-assignment-card-folder" key={index}>
                                                <MultipleAssignmentviewResult
                                                    index={index}
                                                    assignment={assignment}
                                                    startAssignmentPopupHandler={startAssignmentPopupHandler}
                                                    lesson={lesson}
                                                    course={course}
                                                    rubrics={rubrics}
                                                    setcallWebSocket={setcallWebSocket}
                                                    callWebSocket={callWebSocket}
                                                    setwebsocketPayload={setwebsocketPayload}
                                                    assignmentResultHandler={assignmentResultHandler}
                                                    courseType={courseType}
                                                />
                                            </div>
                                        );
                                    })
                                ) : (
                                    <p style={{ textAlign: "center", marginTop: "20px" }}>No assignments found.</p>
                                )}
                            </div>
                                {assignmentPopUp && <MultipleAssignmentviewPopup type={"Assignment"} startAssignmentPopupHandler={startAssignmentPopupHandler} startAssignmentHandler={startAssignmentHandler} rubric={assignmentRubric} assignment={selectedAssignment} index={selectedAssignmentIndex} courseType={courseType} />}
                            </div>
                        </div>
                    </div>
                    {totalPages > 1 && (
                        <PaginationView
                            totalPages={totalPages}
                            next={next}
                            previous={previous}
                            currentPage={currentPage}
                            setCurrentPage={setCurrentPage}
                        />
                    )}
                </div>
            </div>
        </>
    );
}

export default MultipleAssignment;
